import React from 'react';
import './FormControlMessage.css';
import withTheme from '../../hocs/withTheme';

function FormControlMessage({ hidden = false, children = null } : {hidden?: boolean, children?: React.ReactNode}) {
    return (
        <p
            className="form-control-message"
            hidden={hidden}
        >
            {children}
        </p>
    );
}

export default withTheme(FormControlMessage);
